let s=["eth_sign","eth_signTransaction","personal_sign","eth_signTypedData_v4","csw_signUserOperation","secp256k1_sign"];const n=n=>s.includes(n);export{n as isSupportedIframeRpcMethod};
